import { createSelector } from 'reselect';
import { flatMap, flow, get, keys, map, mapValues, pick, pickBy } from 'lodash/fp';

import { getSelectionAndBonus } from '../utils/challengeUtils';
import { getBonusChosen, normaliseSelections } from '../reducers/lineUpReducer';
import { mapBonuses } from './selectionToPost';

function getSelection(lineups, lineupId, playerPositions, teamPositions) {
  try {
    const lineup = lineups.find(l => l.id === lineupId);
    const { selections, bonuses } = getSelectionAndBonus(lineup.selection);

    const lineupSelections = normaliseSelections({}, { selections, lock: true });
    const bonusesChosen = getBonusChosen({}, { bonuses });

    const mapPlayers = flow(
      pick(keys(playerPositions)),
      mapValues(
        flow(
          pickBy(p => !p.isTeam),
          keys,
          map(idStr => idStr.replace('PLAYER_', ''))
        )
      )
    );

    const mapTeams = flow(
      pick(keys(teamPositions)),
      flatMap(
        flow(
          pickBy(p => p.isTeam),
          keys,
          map(idStr => idStr.replace('TEAM_', ''))
        )
      )
    );

    return {
      players: mapPlayers(lineupSelections),
      teams: mapTeams(lineupSelections),
      bonus_selections: mapBonuses(bonusesChosen)
    };
  } catch (err) {
    return {};
  }
}

const selectionByLineup = createSelector(
  get('myTeams.lineups'),
  (state, lineupId) => lineupId,
  get('challenge.playerPositions'),
  get('challenge.teamPositions'),
  getSelection
);

export default selectionByLineup;
